import { Input } from "antd";
import PropTypes from "prop-types";

import classnames from "classnames";
import Label from "../../Label";

const Phone = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  innerRef,
  required,
  direction,
  ...rest
}) => {
  return (
    <div
      className={classnames(
        "input__lmf",
        { __error: touched && errors },
        direction,
      )}
    >
      <Label label={label} icon={icon} required={required} />
      <div className={`input__lmf--field`}>
        <Input
          type="phone"
          inputMode="numeric"
          className={classnames({
            "input--borderd--red": touched && errors,
            "disable--input": rest.disabled,
          })}
          placeholder={placeholder}
          ref={innerRef}
          {...rest}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

Phone.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Phone.defaultProps = {
  label: "",
  placeholder: "",
};
export default Phone;
